import React, { useState, useEffect } from "react";
import BaseCurrency from "../Common/BaseCurrency";
import { millify } from "../../config/helper";
import eyeOpen from "../../assets/images/eye-open.svg";
import eyeClose from "../../assets/images/eye-close.svg";
import { useHistory } from "react-router-dom";
import usePayAxios from "../../config/useAxios";
import { useDispatch, useSelector } from "react-redux";

export default function VerticalCard({ card }) {
  const [showBal, setShowBal] = useState(false);
  const [visibleField, setVisibleField] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [imgLoading, setImgLoading] = useState(true);
  const [imgError, setImgError] = useState(false);
  const { onCall: onCallSensitive, data: sensitiveData } = usePayAxios({
    api: "/api/cards/v1/getCardSensitiveData",
    method: "get",
    showSuccessMessage: false,
  });

  const userData = useSelector(
    (state) => state.cards.profile?.data?.response?.profile,
  );
  const history = useHistory();
  const formatNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };
  const maskCardNumber = (cardNumber) => {
    if (!cardNumber || cardNumber.length < 16) return cardNumber; // Handle invalid card numbers
    return `XXXX XXXX XXXX ${cardNumber.slice(-4)}`;
  };
  const maskExpiryDate = (expiryDate) => (expiryDate ? "XX/XX" : "");
  const ExpiryData = (expiryDate) =>
    expiryDate ? `${expiryDate?.slice(0, 2)}/${expiryDate?.slice(-2)}` : "";
  const maskCVV = (cvv) => (cvv ? "XXX" : "");

  useEffect(() => {
    if (card?.id)
      onCallSensitive({
        params: {
          card_id: card?.id,
        },
      });
  }, [card?.id]);

  useEffect(() => {
    if (!imageSrc && userData?.cards?.data?.imageUrl) {
      setImageSrc(userData.cards.data.imageUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.cards?.data?.imageUrl]);

  return (
    <aside className="aside-width p1 card card-sec">
      <div className="flex-between">
        <span className="summary-title">Card Summary</span>
        {/* <span
                className="active-text cursor"
                onClick={() => {
                  // history.push("/cards");
                  history.push({
                    pathname: `/card-details/${card?.id}`,
                    state: { cardData: card },
                  });
                }}
              >
                View All
              </span> */}
      </div>
      <div className="flex-between">
        {/* -- LEFT COLUMN: balance + stacked details (unchanged behavior) -- */}
        <div className="card-profile-vertical w60">
          <div className="highSmall">
            <label>Available balance: </label>
            <span className="balance-row" onClick={() => setShowBal((b) => !b)}>
              <BaseCurrency /> {showBal ? millify(card?.balance) : "XXXXX"}{" "}
              {showBal ? (
                <EyeComponent image={eyeOpen} />
              ) : (
                <EyeComponent image={eyeClose} />
              )}
            </span>
          </div>
          {/* Small title for the card details section */}
          <div className="card-details-section">
            <span className="card-details-title">Card details:</span>

            <div className="mtHalf ref card-details">
              {/* Card name (masked) */}
              <div className="card-detail-line">
                <span className="card-detail-label">Card Number:</span>
                <span className="card-detail-value">
                  {visibleField === "cardNumber"
                    ? formatNumber(sensitiveData?.response?.cardNumber || "")
                    : maskCardNumber(
                      sensitiveData?.response?.cardNumber ||
                      card?.card_number ||
                      "-",
                    )}
                </span>
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setVisibleField(
                      visibleField === "cardNumber" ? null : "cardNumber",
                    );
                  }}
                  aria-label="toggle-card-number"
                >
                  {visibleField === "cardNumber" ? (
                    <EyeComponent image={eyeOpen} />
                  ) : (
                    <EyeComponent image={eyeClose} />
                  )}
                </button>
              </div>

              {/* VALID UPTO */}
              <div className="card-detail-line">
                <span className="card-detail-label">Valid Upto:</span>
                <span className="card-detail-value">
                  {visibleField === "expiryDate"
                    ? ExpiryData(sensitiveData?.response?.expiryDate)
                    : maskExpiryDate(
                      sensitiveData?.response?.expiryDate ||
                      card?.cardExpiry ||
                      "",
                    )}
                </span>
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setVisibleField(
                      visibleField === "expiryDate" ? null : "expiryDate",
                    );
                  }}
                  aria-label="toggle-expiry"
                >
                  {visibleField === "expiryDate" ? (
                    <EyeComponent image={eyeOpen} />
                  ) : (
                    <EyeComponent image={eyeClose} />
                  )}
                </button>
              </div>

              {/* CVV */}
              <div className="card-detail-line">
                <span className="card-detail-label">CVV:</span>
                <span className="card-detail-value">
                  {visibleField === "cvv"
                    ? sensitiveData?.response?.cvv || "-"
                    : maskCVV(sensitiveData?.response?.cvv || "")}
                </span>
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setVisibleField(visibleField === "cvv" ? null : "cvv");
                  }}
                  aria-label="toggle-cvv"
                >
                  {visibleField === "cvv" ? (
                    <EyeComponent image={eyeOpen} />
                  ) : (
                    <EyeComponent image={eyeClose} />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="w50 flex-end-col">
          {/* <div className="card-image-wrapper">
            <img
              src={userData?.cards?.data?.imageUrl}
              alt="Credit card"
              className="card-image"
            />

            <span className="card-name-vertical">
              {card?.employee_details.name}
            </span>
          </div> */}
          <div className="card-image-wrapper">
            {imgLoading && (
              <div className="card-image-placeholder" aria-hidden>
                <div
                  style={{
                    width: 160,
                    height: 260,
                    background: "#f5f5f6",
                    borderRadius: 8,
                  }}
                />
              </div>
            )}

            <img
              src={
                imageSrc || userData?.cards?.data?.imageUrl || card?.imageUrl
              }
              alt="Card"
              className="card-image"
              loading="eager"
              decoding="async"
              onLoad={(e) => {
                setImgLoading(false);
                setImgError(false);
              }}
              onError={(e) => {
                setImgLoading(false);
                setImgError(true);
                console.warn("Card image failed to load:", e.target.src);
              }}
              style={{
                display: imgLoading ? "none" : "block",
                // width: 240,
                borderRadius: 8,
              }}
              onClick={(e) => {
                e.stopPropagation();
                history.push({
                  pathname: `/card-details/${card?.id}`,
                  state: { cardData: card, isVertical: true },
                });
              }}
            />

            {/* fall-back text if image failed */}
            {imgError && (
              <div
                className="card-image-fallback"
                style={{ color: "#999", marginTop: 8 }}
              >
                Card image unavailable
              </div>
            )}

            {/* display name alongside image */}
            <span className="card-name-vertical">
              {(card?.employee_details?.name).toUpperCase()}
            </span>
            {/* <span className="card-name-vertical">
              SIVA SANJAY KUMAR DEVISETTY
            </span> */}
          </div>
          <div className="flex-between max-wd">
            <button
              className="primary-btn"
              onClick={() => {
                history.push("/card-details/" + card?.id, {
                  cardData: card,
                  viewTxns: true,
                  isVertical: true,
                });
              }}
            >
              View Transactions
            </button>
            <button
              className="nm-btn"
              onClick={() => {
                history.push("/card-details/" + card?.id, {
                  cardData: card,
                  isVertical: true,
                });
              }}
            >
              Settings
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
}

const EyeComponent = ({ image }) => {
  return (
    <div style={{ display: "contents" }}>
      <img src={image} alt="eye image" />
    </div>
  );
};
